// Application constants

export const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

export const USER_ROLES = {
  ADMIN: "admin",
  SUPER_ADMIN: "super-admin",
};

export const PRODUCT_CATEGORIES = [
  "Garments",
  "Textiles",
  "Apparel",
  "Uniforms",
  "Accessories",
  "Other",
];

export const GALLERY_CATEGORIES = [
  "Products",
  "Manufacturing",
  "Quality Control",
  "Team",
  "Facilities",
  "Events",
  "Other",
];

export const INQUIRY_STATUS = {
  NEW: "new",
  IN_PROGRESS: "in-progress",
  RESPONDED: "responded",
  CLOSED: "closed",
};

export const INQUIRY_PRIORITY = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
};

export const PRODUCT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const IMAGE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const PAGINATION_LIMITS = [10, 20, 50, 100];

export const FILE_UPLOAD_LIMITS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILES_COUNT: 10,
  ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  ALLOWED_DOCUMENT_TYPES: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/plain",
  ],
};

export const COMPANY_INFO = {
  name: "OM Maruti Creation",
  tagline: "Premium Textile Manufacturing Company",
  description:
    "Leading manufacturer of high-quality textile products with over 20 years of experience in the industry.",
  address: "Peenya 2nd Stage, Bangalore - 560058",
  phone: "+91 0987654321",
  email: "info@ommaruticreation.com",
  website: "https://www.ommaruticreation.com",
  established: "2006",
  employees: "1500+",
  certifications: ["ISO 9001:2015", "GOTS Certified", "OEKO-TEX Standard 100"],
};

export const SOCIAL_LINKS = {
  facebook: "#",
  instagram: "#",
  linkedin: "#",
  youtube: "#",
  whatsapp: "#",
};

export const NAVIGATION_LINKS = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About Us" },
  { path: "/service", label: "Our Services" },
  { path: "/products", label: "Our Products" },
  { path: "/gallery", label: "Gallery" },
  { path: "/contact", label: "Contact Us" },
];

export const ADMIN_NAVIGATION_LINKS = [
  { path: "/admin/dashboard", label: "Dashboard", icon: "dashboard" },
  { path: "/admin/products", label: "Products", icon: "products" },
  { path: "/admin/gallery", label: "Gallery", icon: "gallery" },
  { path: "/admin/inquiries", label: "Inquiries", icon: "inquiries" },
  { path: "/admin/settings", label: "Settings", icon: "settings" },
];

export const THEME_COLORS = {
  primary: "#2563eb",
  secondary: "#64748b",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6",
  light: "#f8fafc",
  dark: "#1e293b",
};

export const BREAKPOINTS = {
  xs: "475px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};
